import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../../services/common.service';
import { ApiService } from '../../../services/api.service';
import { DatatableComponent } from '@siemens/ngx-datatable';
import { Location } from '@angular/common';
import * as moment from "moment";
// import { Select2OptionData } from 'ng-select2';
// import { Options } from 'select2';

@Component({
  selector: 'app-templateupload',
  templateUrl: './templateupload.page.html',
  styleUrls: ['./templateupload.page.scss'],
})
export class TemplateuploadPage implements OnInit {
  @ViewChild('uploader', { static: false }) uploader: any;
  @ViewChild('f', { read: NgForm }) form: any;
 templateId:any;
 docxName:any;
 activeVersionId: any
 fileUpload:any;
 rows:any=[];
  breadcrumb: any = {
    TemplateName: null
  }
  showPage:boolean =false;
  submitted: boolean = false;
  fileValidation: boolean = false;
  postData: any;
  errorMessage: string = '';
  showInfoBlock: boolean;
  sourceDocumentTemplateId: any;
  templateList: Array<any> = [];
  currentVersionList: Array<any> = [];
  constructor(private router: Router, private route: ActivatedRoute,
    private formBuilder: FormBuilder, private _apiService: ApiService, public _commonService: CommonService, private location: Location,private ngZone: NgZone)
    {

    }

  ngOnInit() {
  }

  ionViewWillEnter(){
    this.fileValidation = false;
  }
  ionViewDidLeave(){
    this.showInfoBlock = false;
    this.postData = {};
    this.showPage=false;
    sessionStorage.removeItem('TemplateName');
    sessionStorage.removeItem('VersionId');

  }

  ionViewDidEnter() {
    this.templateId= this.route.snapshot.paramMap.get('id');
    if (this.templateId == '0') {
      this.templateId = null;
      // this.goBack();

    }
    this.getTemplateList();
    if (this.templateId && sessionStorage.VersionId) {
      this.breadcrumb.TemplateName = sessionStorage.TemplateName;
      this.getTemplateDetails();
      this.getVersion(this.templateId, true);

    }
    this.showPage=true



    }

    onVersionChanged(event){
      this.activeVersionId = event ? event : null
    }

    onTemplateChanged(event){
      this.sourceDocumentTemplateId = event ? event : null;
      if(this.sourceDocumentTemplateId) {
        this.getVersion(this.sourceDocumentTemplateId, false);
      } else {
        this.rows = this.currentVersionList;
      }

    }

    async getVersion(id, firstLoad){
      try{
        this._commonService.presentLoading();
        let res = await this._apiService.getVersions(id, "", '', '', 1);
        this.rows = [...res.body.filter(f => f.IsArchive != 1)];
        if(firstLoad) {
          this.currentVersionList = JSON.parse(JSON.stringify(this.rows));
          if(this.rows.length > 0) {
            this.sourceDocumentTemplateId = id;
          }
        }
        this._commonService.log(this.rows, this._commonService.LOG);
        this._commonService.dismiss();

      }catch(error){
        this._commonService.dismiss();
        this._commonService.log(error, this._commonService.ERROR);
      }
    }

    async getTemplateList() {
      try {
        let res = await this._apiService.getDocumentTemplates("", '', '', 1, 0, 0, '');
        this.templateList = res.body;
      } catch (error) {

      }
    }

    async getTemplateDetails(){
      try{
        this._commonService.presentLoading();


        this._commonService.dismiss();

      }catch(error){
        this._commonService.dismiss();
      }
    }
    async onSelectFile(files: any){
      let items: any = [];
      try {
        if (files.length > 0 && files.length < 50) {
          // this._commonService.presentLoading();
          // this.fileType='';

            let fileName = files[0].name;
            this.fileUpload = files[0];
            let ext = null;
            this.docxName=fileName;
            // if(fileName){
            //   ext = fileName.split('.').pop();
            //   if(ext && ext=='docx'){
            //     let formData = new FormData();
            //     formData.append('FileName',this.docxName);
            //     formData.append('VersionName', localStorage.VersionName?localStorage.VersionName:null);
            //     formData.append('DocumentTemplateId', this.templateId);
            //     await this._apiService.postTemplateVersion(formData);
            //     this._commonService.dismiss();

            //   }
            // }else{

            //   this._commonService.dismiss();
            //   this._commonService.presentAlert("", this._commonService.getLocalTranslation('label-unsupportedFileType'));

            // }

        this._commonService.dismiss();
      }     else if (files.length > 50){
        this._commonService.dismiss();
        this._commonService.presentAlert("", this._commonService.getLocalTranslation('label-fileNumberExceeded'));
      }
    }catch(error){
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
      }
      this.uploader.nativeElement.value = null;
    }

    uploadTemplate(){
      this.uploader.nativeElement.click();
    //   window.addEventListener('focus', event => {
    //     console.log(event);
    //     window.onfocus = this.checkme;
    // });
    window.addEventListener('focus', this.checkvalidation, false);
    //window.onfocus = this.checkvalidation;

    }
    checkvalidation = () => {
      setTimeout(() => {
        this.fileValidation = true;
      }, 500);
      window.removeEventListener('focus', this.checkvalidation, false);
    }

    async onSort(event){
      // const sort = event.sorts[0];
      // this.page.orderBy = sort.prop.toLowerCase();
      // this.page.orderDir = sort.dir;
      // this.setPage({ offset: this.page.pageNumber }, this._commonService.searchText);
    }

    goBack() {
      this.router.navigate(['maintenance/documentgenerator/'+this.templateId], { replaceUrl: true })
    }

    goBackList(){
      this.router.navigate(['maintenance/documentgenerator'], { replaceUrl: true })
    }

    async onSubmit(){
      this.submitted = true
      if(this.form.invalid){
        return
      }
      this._commonService.presentLoading();
      try{
      let ext = null;
      if(this.docxName){
        ext = this.docxName.split('.').pop();
        if(ext && ext=='docx'){
          let formData = new FormData();
          formData.append('file',this.fileUpload);
          formData.append('FileName',this.docxName);
          formData.append('VersionName', '');
          formData.append('DocumentTemplateId', this.templateId);
          if(this.activeVersionId){
            formData.append('SourceVersionId', this.activeVersionId);
          }

          if(this.sourceDocumentTemplateId){
            formData.append('SourceDocumentTemplateId', this.sourceDocumentTemplateId);
          }
          let response = await this._apiService.postTemplateVersion(formData);
          this.showInfoBlock = true;
          if(this.activeVersionId) {
            this.postData = response.body;
          }
          this._commonService.dismiss();
          if(this.rows.length == 0) {
            this.goBack()
          }
          this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));

        }
      }else{

        this._commonService.dismiss();
        this._commonService.presentAlert("", this._commonService.getLocalTranslation('label-unsupportedFileType'));

      }
      this._commonService.dismiss();

    }catch(error){
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
      this.postData = '';
      if(error.status != 500) {
        this.errorMessage = error.error.message;
      }
    }
    }

    onActionChange(obj) {

      switch (obj.Action) {
        case "save":
            this.onSubmit();
            break;
        case "delete":
            // this.delete();
            break;
        case "backToList":
            this.goBackList();
            break;
        case "backToMain":
            this.router.navigate(['maintenance'], { replaceUrl: true })
            break;
        case "back":
            this.goBack();
            break;
        case "upload":
            this.uploadTemplate();


        }

    }

  }




